export const staticRoutes = {
  labRequestSamples: {
    base: '/lab-request-samples',
    printView: '/lab-request-samples/print',
  },
  developmentView: {
    base: '/development',
  },
}